import { render, staticRenderFns } from "./EncounterLabs.vue?vue&type=template&id=42dff947&"
import script from "./EncounterLabs.vue?vue&type=script&lang=js&"
export * from "./EncounterLabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports